<form >
  <div class="scrollbar app px-0">
    <div class="card-header" translate>lblShiftTimings</div>
    <div class="pad15 pt-0">
        <div class="mt-2 p-0">
            <div class="row align-items-end">
              <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                <label for="name" translate>lblOccasionName</label>
                <div class="lbl-info">
                  <input [(ngModel)]="occasionname" class="form-control mb-2" [ngModelOptions]="{standalone: true}" maxlength="30"
                    placeholder="Enter Occasion Name" [readonly]="true">
                </div>
              </div>
              <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                    <label for="startDate" translate>lblStartDate
                       </label>
                    <div class="lbl-info">
                            <input class="form-control mb-2" maxlength="30" [ngModelOptions]="{standalone: true}" [(ngModel)] ="startdate"
                            [readonly]="true">
                          </div>
                  </div>
  
                  <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                    <label for="endDate" translate>lblEndDate
                       </label>
                    <div class="lbl-info">
                            <input class="form-control mb-2" maxlength="30" [ngModelOptions]="{standalone: true}" [(ngModel)] ="enddate"
                             [readonly]="true">
                          </div>
                  </div>
              </div></div>
        <div class="p-0">
            <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group" *ngFor="let itm of OccasionList">
          <label class="mr10"><input name="options" ng-control="options" type="radio" [value]="itm.rowId" (change)="ChangeOccasion()"  [(ngModel)]="SelectedRadioButton" > {{itm.occasionName}}</label>
          </div></div></div>
      <div class="table-responsive form-check tableMx-15">

      
      <table class="tablest1">
        <thead>
          <tr>
            <th style="width:10%" class="text-center" scope="col" translate>lblIsWorking</th>
            <th style="width:15%" scope="col" translate>lblDay</th>
            <th style="width:15%" scope="col" translate>lblDealerShiftDetails</th>
            <th style="width:30%" scope="col" translate>lblSlotFrom</th>
            <th style="width:30%" scope="col" translate>lblSlotTill</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let t of shiftTime; let i = index">
              <td class="text-center">
                <div class="custom-checkbox">
                  <input type="checkbox" [(ngModel)]="t.isActive" [checked]="t.isActive"
                    [ngModelOptions]="{standalone: true}">
                </div>
              </td>
              <td>{{t.dayText}}</td>
              <td translate> {{t.dealerShiftDetails}} </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="t.openingTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeOpeningHours(i,$event)"></ngb-timepicker>

                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="t.closingTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeClosingHours(i,$event)"></ngb-timepicker>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    </div>
 

  <div class="mb15">
    <div class="card-header" translate>lblBreakTimings</div>
    <div class="pad15 pt-0">
      <div class="table-responsive tableMx-15">
      <table class="tablest1" aria-describedby="LunchTimings">
        <thead>
          <tr>
            <th style="width:40%" scope="col" translate>lblName </th>
            <th style="width:30%" scope="col" translate>lblStartTime </th>
            <th style="width:30%" scope="col" translate>lblEndTime </th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr>
              <td>
                <div class="date iconfix">
                  <span translate>lblLunchBreak</span>
                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="lunchShift.lunchStartTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="getstartHours($event, lunchShift)"></ngb-timepicker>
                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="lunchShift.lunchEndTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="getendHours($event, lunchShift)"></ngb-timepicker>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="date iconfix">
                  <span translate>lblBreak1</span>
                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="lunchShift.break1StartTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="getstartHoursBreak1($event, lunchShift)"></ngb-timepicker>
                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="lunchShift.break1EndTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="getendHoursBreak1($event, lunchShift)"></ngb-timepicker>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="date iconfix">
                  <span translate>lblBreak2</span>
                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="lunchShift.break2StartTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="getstartHoursBreak2($event, lunchShift)"></ngb-timepicker>
                </div>
              </td>
              <td>
                <div class="date iconfix">
                  <ngb-timepicker [(ngModel)]="lunchShift.break2EndTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="getendHoursBreak2($event, lunchShift)"></ngb-timepicker>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</div>

  <div class="p-3 bg-light pp-footer-top-brdr">
  <div class='row'>
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
      <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" [disabled]="isDisabled"  (click)="EditMechanicOpeningHoursDetail(false)" translate aria-label="Center Align">lblSaveChanges</button>
      <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" [disabled]="isDisabled" (click)="EditMechanicOpeningHoursDetail(true)" translate aria-label="Center Align">lblSaveAndClose</button>
      <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblBack</a>
    </div>
  </div>
</div>
</form>